export default (name) => [name, `${name}.success`, `${name}.fail`, `${name}.fail`, `${name}.fail`]



// WEBPACK FOOTER //
// ./src/state/utils/asyncTypesFactory.js